import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { SectionM } from '../../oasis-sections/section-m';
import { OASIS } from '../../oasis-types';
import { isActive, isTimepoint, TEMP_VERSION } from '../util';
// eslint-disable-next-line
export const sectionMSkipPatterns = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
        const payload = input;
        // M-skip pattern-5112 If M0100_ASSMT_REASON = [01,03,09] and M1306_UNHLD_STG2_PRSR_ULCR = [0], then all active items from M1307_OLDST_STG2_AT_DSCHRG through M1311_NSTG_DEEP_TSUE_SOCROC_F2 must equal [^].
        if (isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100) &&
            payload.SectionM?.m1306 === '0' &&
            [
                payload.SectionM?.m1307,
                payload.SectionM.m1307DT,
                payload?.SectionM?.m1311?.m1311a1,
                payload?.SectionM?.m1311?.m1311b1,
                payload?.SectionM?.m1311?.m1311c1,
                payload?.SectionM?.m1311?.m1311d1,
                payload?.SectionM?.m1311?.m1311e1,
                payload?.SectionM?.m1311?.m1311f1,
            ].some((item) => item)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5112 If M1306 = No, then all active items from M1307 through M1311F1 must be empty.',
                path: ['SectionM', 'm1306'],
            });
        }
        if (isTimepoint([OASIS.DSCH], payload.SectionA?.m0100) &&
            payload.SectionM?.m1306 === '0' &&
            [
                payload.SectionM?.m1307,
                payload.SectionM.m1307DT,
                payload?.SectionM?.m1311?.m1311a1,
                payload?.SectionM?.m1311?.m1311a2,
                payload?.SectionM?.m1311?.m1311b1,
                payload?.SectionM?.m1311?.m1311b2,
                payload?.SectionM?.m1311?.m1311c1,
                payload?.SectionM?.m1311?.m1311c2,
                payload?.SectionM?.m1311?.m1311d1,
                payload?.SectionM?.m1311?.m1311d2,
                payload?.SectionM?.m1311?.m1311e1,
                payload?.SectionM?.m1311?.m1311e2,
                payload?.SectionM?.m1311?.m1311f1,
                payload?.SectionM?.m1311?.m1311f2,
            ].some((item) => item)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5112 If M1306 = 0, then all active items from M1307 through M1311F2 must be empty.',
                path: ['SectionM', 'm1306'],
            });
        }
        // M-skip pattern-5123 If M0100_ASSMT_REASON = [01,03,09] and M1306_UNHLD_STG2_PRSR_ULCR = [1], then the following items must not equal [^]: M1307_OLDST_STG2_AT_DSCHRG, M1311_NBR_PRSULC_STG2_A1, M1311_NBR_PRSULC_STG3_B1, M1311_NBR_PRSULC_STG4_C1, M1311_NSTG_DRSG_D1, M1311_NSTG_CVRG_E1, M1311_NSTG_DEEP_TSUE_F1.
        if (isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100) &&
            payload.SectionM?.m1306 === '1' &&
            [
                payload?.SectionM?.m1311?.m1311a1,
                payload?.SectionM?.m1311?.m1311b1,
                payload?.SectionM?.m1311?.m1311c1,
                payload?.SectionM?.m1311?.m1311d1,
                payload?.SectionM?.m1311?.m1311e1,
                payload?.SectionM?.m1311?.m1311f1,
            ].some((item) => !item)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5123 If M1306 = 1, then all items from M1311A1 through M1311F1 must NOT be empty.',
                path: ['SectionM', 'm1306'],
            });
        }
        if (isTimepoint([OASIS.DSCH], payload.SectionA?.m0100) &&
            payload.SectionM?.m1306 === '1' &&
            [
                payload.SectionM?.m1307,
                payload?.SectionM?.m1311?.m1311a1,
                payload?.SectionM?.m1311?.m1311b1,
                payload?.SectionM?.m1311?.m1311c1,
                payload?.SectionM?.m1311?.m1311d1,
                payload?.SectionM?.m1311?.m1311e1,
                payload?.SectionM?.m1311?.m1311f1,
            ].some((item) => !item)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5123 If M1306 = 1, then all items from M1307 through M1311F1 must NOT be empty.',
                path: ['SectionM', 'm1306'],
            });
        }
        // M-skip pattern-4030 If M1307_OLDST_STG2_AT_DSCHRG=[01,NA], then if M1307_OLDST_STG2_ONST_DT is active it must equal [^].
        if (['01', 'NA'].includes(payload.SectionM?.m1307 || '') && payload.SectionM?.m1307DT) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4030 If M1307 = 01 or NA, then Onset Date must be empty.',
                path: ['SectionM', 'm1307'],
            });
        }
        // M-skip pattern-4040 If M1307_OLDST_STG2_AT_DSCHRG=[02], then if M1307_OLDST_STG2_ONST_DT is active it must not equal [^].
        if (payload.SectionM?.m1307 === '02' && !payload.SectionM?.m1307DT) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4030 If M1307 = 02, then Onset Date must NOT be empty.',
                path: ['SectionM', 'm1307'],
            });
        }
        // M-skip pattern-5371
        // (a) If M1311_NBR_PRSULC_STG2_A1=[0], then if M1311_NBR_ULC_SOCROC_STG2_A2 is active, it must be equal to [^].
        if (payload.SectionM?.m1311?.m1311a1 &&
            payload.SectionM?.m1311?.m1311a1 === '0' &&
            isActive(SectionM.m1311.fields.a2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311a2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5371 If M1311 = 0, then M1311A2 must be empty.',
                path: ['SectionM', 'm1311', 'm1311a2'],
            });
        }
        // (b) If M1311_NBR_PRSULC_STG2_A1>0, then if M1311_NBR_ULC_SOCROC_STG2_A2 is active, it must not be equal to [^].
        if (payload.SectionM?.m1311?.m1311a1 &&
            payload.SectionM?.m1311?.m1311a1 > '0' &&
            isActive(SectionM.m1311.fields.a2, TEMP_VERSION, payload.SectionA?.m0100) &&
            !payload.SectionM?.m1311?.m1311a2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5371 If M1311 = 0, then M1311A2 must NOT be empty.',
                path: ['SectionM', 'm1311', 'm1311a2'],
            });
        }
        // M-skip pattern-5381
        // (a) If M1311_NBR_PRSULC_STG3_B1=[0], then if M1311_NBR_ULC_SOCROC_STG3_B2 is active, it must be equal to [^].
        if (payload.SectionM?.m1311?.m1311b1 &&
            payload.SectionM?.m1311?.m1311b1 === '0' &&
            isActive(SectionM.m1311.fields.b2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311b2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5381 If M1311 = 0, then M1311B2 must be empty.',
                path: ['SectionM', 'm1311', 'm1311b2'],
            });
        }
        // (b) If M1311_NBR_PRSULC_STG3_B1>0, then if M1311_NBR_ULC_SOCROC_STG3_B2 is active, it must not be equal to [^].
        if (payload.SectionM?.m1311?.m1311b1 &&
            payload.SectionM?.m1311?.m1311b1 > '0' &&
            isActive(SectionM.m1311.fields.b2, TEMP_VERSION, payload.SectionA?.m0100) &&
            !payload.SectionM?.m1311?.m1311b2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5381 If M1311 = 0, then M1311B2 must NOT be empty.',
                path: ['SectionM', 'm1311', 'm1311b2'],
            });
        }
        // M-skip pattern-5391
        // (a) If M1311_NBR_PRSULC_STG4_C1=[0], then if M1311_NBR_ULC_SOCROC_STG4_C2 is active, it must be equal to [^].
        if (payload.SectionM?.m1311?.m1311c1 &&
            payload.SectionM?.m1311?.m1311c1 === '0' &&
            isActive(SectionM.m1311.fields.c2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311c2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5391 If M1311 = 0, then M1311C2 must be empty.',
                path: ['SectionM', 'm1311', 'm1311c2'],
            });
        }
        // (b) If M1311_NBR_PRSULC_STG4_C1>0, then if M1311_NBR_ULC_SOCROC_STG4_C2 is active, it must not be equal to [^].
        if (payload.SectionM?.m1311?.m1311c1 &&
            payload.SectionM?.m1311?.m1311c1 > '0' &&
            isActive(SectionM.m1311.fields.c2, TEMP_VERSION, payload.SectionA?.m0100) &&
            !payload.SectionM?.m1311?.m1311c2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5391 If M1311 = 0, then M1311C2 must NOT be empty.',
                path: ['SectionM', 'm1311', 'm1311c2'],
            });
        }
        // M-skip pattern-5411
        // (a) If M1311_NSTG_CVRG_E1=[0], then if M1311_NSTG_CVRG_SOCROC_E2 is active, it must be equal to [^].
        if (payload.SectionM?.m1311?.m1311e1 &&
            payload.SectionM?.m1311?.m1311e1 === '0' &&
            isActive(SectionM.m1311.fields.e2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311e2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5411 If M1311 = 0, then M1311E2 must be empty.',
                path: ['SectionM', 'm1311', 'm1311e2'],
            });
        }
        // (b) If M1311_NSTG_CVRG_E1 >0, then if M1311_NSTG_CVRG_SOCROC_E2 is active, it must not be equal to [^].
        if (payload.SectionM?.m1311?.m1311e1 &&
            payload.SectionM?.m1311?.m1311e1 > '0' &&
            isActive(SectionM.m1311.fields.e2, TEMP_VERSION, payload.SectionA?.m0100) &&
            !payload.SectionM?.m1311?.m1311e2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5411 If M1311 = 0, then M1311E2 must NOT be empty.',
                path: ['SectionM', 'm1311', 'm1311e2'],
            });
        }
        // M-skip pattern-5421
        // (a) If M1311_NSTG_DEEP_TSUE_F=[0], then if M1311_NSTG_DEEP_TSUE_SOCROC_F2 is active, it must be equal to [^].
        if (payload.SectionM?.m1311?.m1311f1 &&
            payload.SectionM?.m1311?.m1311f1 === '0' &&
            isActive(SectionM.m1311.fields.f2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311f2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5421 If M1311 = 0, then M1311F2 must be empty.',
                path: ['SectionM', 'm1311', 'm1311f2'],
            });
        }
        // (b) If M1311_NSTG_DEEP_TSUE_F1 >0, then if M1311_NSTG_DEEP_TSUE_SOCROC_F2 is active, it must not be equal to [^].
        if (payload.SectionM?.m1311?.m1311f1 &&
            payload.SectionM?.m1311?.m1311f1 > '0' &&
            isActive(SectionM.m1311.fields.f2, TEMP_VERSION, payload.SectionA?.m0100) &&
            !payload.SectionM?.m1311?.m1311f2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5421 If M1311 = 0, then M1311F2 must NOT be empty.',
                path: ['SectionM', 'm1311', 'm1311f2'],
            });
        }
        // M-skip pattern-5401
        // (a) If M1311_NSTG_DRSG_D1=[0], then if M1311_NSTG_DRSG_SOCROC_D2 is active, it must be equal to [^].
        if (payload.SectionM?.m1311?.m1311d1 &&
            payload.SectionM?.m1311?.m1311d1 === '0' &&
            isActive(SectionM.m1311.fields.d2, TEMP_VERSION, payload.SectionA?.m0100) &&
            payload.SectionM?.m1311?.m1311d2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5401 If M1311 = 0, then M1311F2 must be empty.',
                path: ['SectionM', 'm1311', 'm1311d2'],
            });
        }
        // (b) If M1311_NSTG_DRSG_D1>0, then if M1311_NSTG_DRSG_SOCROC_D2 is active, it must not be equal to [^].
        if (payload.SectionM?.m1311?.m1311d1 &&
            payload.SectionM?.m1311?.m1311d1 > '0' &&
            isActive(SectionM.m1311.fields.d2, TEMP_VERSION, payload.SectionA?.m0100) &&
            !payload.SectionM?.m1311?.m1311d2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-5401 If M1311 = 0, then M1311F2 must NOT be empty.',
                path: ['SectionM', 'm1311', 'm1311d2'],
            });
        }
        // M-skip pattern-4221 If M0100_ASSMT_REASON = [01,03,09], and M1330_STAS_ULCR_PRSNT = [00,03], then all active items from M1332_NBR_STAS_ULCR through M1334_STUS_PRBLM_STAS_ULCR must equal [^].
        if (isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100) &&
            ['00', '03'].includes(payload.SectionM?.m1330 || '') &&
            [payload.SectionM?.m1332, payload.SectionM?.m1334].some((item) => Boolean(item))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4221 If M1330_STAS_ULCR_PRSNT = 0 or 3, then items M1332 and M1334 must be empty.',
                path: ['SectionM', 'm1330'],
            });
        }
        if (isTimepoint([OASIS.DSCH], payload.SectionA?.m0100) &&
            ['00', '03'].includes(payload.SectionM?.m1330 || '') &&
            Boolean(payload.SectionM?.m1334)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4221 If M1330_STAS_ULCR_PRSNT = 0 or 3, then M1334 must be empty.',
                path: ['SectionM', 'm1330'],
            });
        }
        // M-skip pattern-4231 If M0100_ASSMT_REASON = [01,03,09] and M1330_STAS_ULCR_PRSNT = [01,02], then all active items from M1332_NBR_STAS_ULCR through M1334_STUS_PRBLM_STAS_ULCR must not equal [^].
        if (isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100) &&
            ['01', '02'].includes(payload.SectionM?.m1330 || '') &&
            [payload.SectionM?.m1332, payload.SectionM?.m1334].some((item) => !item)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4231 If M1330_STAS_ULCR_PRSNT = 1 or 2, then items M1332 and M1334 must NOT be empty.',
                path: ['SectionM', 'm1330'],
            });
        }
        if (isTimepoint([OASIS.DSCH], payload.SectionA?.m0100) &&
            ['01', '02'].includes(payload.SectionM?.m1330 || '') &&
            !payload.SectionM?.m1334) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4231 If M1330_STAS_ULCR_PRSNT = 1 or 2, then M1334 must NOT be empty.',
                path: ['SectionM', 'm1334'],
            });
        }
        // M-skip pattern-4241 If M0100_ASSMT_REASON = [01,03,09] and M1340_SRGCL_WND_PRSNT = [00,02], then if M1342_STUS_PRBLM_SRGCL_WND is active it must equal [^].
        if (isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload.SectionA?.m0100) &&
            ['00', '02'].includes(payload.SectionM?.m1340 || '') &&
            isActive(SectionM.m1342, TEMP_VERSION, payload?.SectionA?.m0100) &&
            payload?.SectionM?.m1342) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4241 If M1340_SRGCL_WND_PRSNT = 0 or 2, then M1342 must be empty.',
                path: ['SectionM', 'm1340'],
            });
        }
        // M-skip pattern-4251 If M0100_ASSMT_REASON = [01,03,09], and M1340_SRGCL_WND_PRSNT = [01], then if M1342_STUS_PRBLM_SRGCL_WND is active it must not equal [^].
        if (isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload.SectionA?.m0100) &&
            payload.SectionM?.m1340 === '01' &&
            isActive(SectionM.m1342, TEMP_VERSION, payload?.SectionA?.m0100) &&
            !payload?.SectionM?.m1342) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4241 If M1340_SRGCL_WND_PRSNT = 1, then M1342 must NOT be empty.',
                path: ['SectionM', 'm1342'],
            });
        }
    }
    else if (!field) {
        // section level
        // eslint-disable-next-line
        const payload = input;
    }
    else {
        // field level
    }
};
// M-skip pattern-5112 If M0100_ASSMT_REASON = [01,03,09] and M1306_UNHLD_STG2_PRSR_ULCR = [0], then all active items from M1307_OLDST_STG2_AT_DSCHRG through M1311_NSTG_DEEP_TSUE_SOCROC_F2 must equal [^].
// M-skip pattern-5123 If M0100_ASSMT_REASON = [01,03,09] and M1306_UNHLD_STG2_PRSR_ULCR = [1], then the following items must not equal [^]: M1307_OLDST_STG2_AT_DSCHRG, M1311_NBR_PRSULC_STG2_A1, M1311_NBR_PRSULC_STG3_B1, M1311_NBR_PRSULC_STG4_C1, M1311_NSTG_DRSG_D1, M1311_NSTG_CVRG_E1, M1311_NSTG_DEEP_TSUE_F1.
// M-skip pattern-4030 If M1307_OLDST_STG2_AT_DSCHRG=[01,NA], then if M1307_OLDST_STG2_ONST_DT is active it must equal [^].
// M-skip pattern-4040 If M1307_OLDST_STG2_AT_DSCHRG=[02], then if M1307_OLDST_STG2_ONST_DT is active it must not equal [^].
// M-skip pattern-5371
// (a) If M1311_NBR_PRSULC_STG2_A1=[0], then if M1311_NBR_ULC_SOCROC_STG2_A2 is active, it must be equal to [^].
// (b) If M1311_NBR_PRSULC_STG2_A1>0, then if M1311_NBR_ULC_SOCROC_STG2_A2 is active, it must not be equal to [^].
// M-skip pattern-5381
// (a) If M1311_NBR_PRSULC_STG3_B1=[0], then if M1311_NBR_ULC_SOCROC_STG3_B2 is active, it must be equal to [^].
// (b) If M1311_NBR_PRSULC_STG3_B1>0, then if M1311_NBR_ULC_SOCROC_STG3_B2 is active, it must not be equal to [^].
// M-skip pattern-5391
// (a) If M1311_NBR_PRSULC_STG4_C1=[0], then if M1311_NBR_ULC_SOCROC_STG4_C2 is active, it must be equal to [^].
// (b) If M1311_NBR_PRSULC_STG4_C1>0, then if M1311_NBR_ULC_SOCROC_STG4_C2 is active, it must not be equal to [^].
// M-skip pattern-5411
// (a) If M1311_NSTG_CVRG_E1=[0], then if M1311_NSTG_CVRG_SOCROC_E2 is active, it must be equal to [^].
// (b) If M1311_NSTG_CVRG_E1 >0, then if M1311_NSTG_CVRG_SOCROC_E2 is active, it must not be equal to [^].
// M-skip pattern-5421
// (a) If M1311_NSTG_DEEP_TSUE_F=[0], then if M1311_NSTG_DEEP_TSUE_SOCROC_F2 is active, it must be equal to [^].
// (b) If M1311_NSTG_DEEP_TSUE_F1 >0, then if M1311_NSTG_DEEP_TSUE_SOCROC_F2 is active, it must not be equal to [^].
// M-skip pattern-5401
// (a) If M1311_NSTG_DRSG_D1=[0], then if M1311_NSTG_DRSG_SOCROC_D2 is active, it must be equal to [^].
// (b) If M1311_NSTG_DRSG_D1>0, then if M1311_NSTG_DRSG_SOCROC_D2 is active, it must not be equal to [^].
// M-skip pattern-4221 If M0100_ASSMT_REASON = [01,03,09], and M1330_STAS_ULCR_PRSNT = [00,03], then all active items from M1332_NBR_STAS_ULCR through M1334_STUS_PRBLM_STAS_ULCR must equal [^].
// M-skip pattern-4231 If M0100_ASSMT_REASON = [01,03,09] and M1330_STAS_ULCR_PRSNT = [01,02], then all active items from M1332_NBR_STAS_ULCR through M1334_STUS_PRBLM_STAS_ULCR must not equal [^].
// M-skip pattern-4241 If M0100_ASSMT_REASON = [01,03,09] and M1340_SRGCL_WND_PRSNT = [00,02], then if M1342_STUS_PRBLM_SRGCL_WND is active it must equal [^].
// M-skip pattern-4251 If M0100_ASSMT_REASON = [01,03,09], and M1340_SRGCL_WND_PRSNT = [01], then if M1342_STUS_PRBLM_SRGCL_WND is active it must not equal [^].
